// extracted by mini-css-extract-plugin
export var breadcrumb = "_1b-2";
export var breadcrumbArrow = "_1b-3";
export var breadcrumbs = "_1b-0";
export var link = "_1b-4";
export var small = "_1b-1";